import { FieldsManagerType } from '.'

export const tableFields:FieldsManagerType[] = [
  {
    tableSection:'companies',
    whichFieldsToShow:[
      {checked:false, field:'cnpj', fieldName:'CNPJ'},
      {checked:false, field:'companyName', fieldName:'Razão social'},
      {checked:false, field:'stateRegistration', fieldName:'Inscrição Estadual'},
      {checked:false, field:'contactName', fieldName:'Nome do contato'},
      {checked:false, field:'phone', fieldName:'Telefone'},
      {checked:false, field:'email', fieldName:'E-mail'},
      {checked:false, field:'companyTypes', fieldName:'Tipo'},
      {checked:false, field:'activedDays', fieldName:'Dias ativos'},
    ]
  },
  {
    tableSection:'stock',
    whichFieldsToShow:[
      {checked:false, field:'code', fieldName:'Código'},
      {checked:false, field:'material', fieldName:'Material'},
      {checked:false, field:'format', fieldName:'Formato'},
      {checked:false, field:'finishing', fieldName:'Acabamento'},
      {checked:false, field:'fabrication', fieldName:'Fabricação'},
      {checked:false, field:'heatTreatment', fieldName:'Tratamento Térmico'},
      {checked:false, field:'originCountry', fieldName:'País de Origem'},
      {checked:false, field:'supplier', fieldName:'Fornecedor'},
      {checked:false, field:'stockStreet', fieldName:'Rua do Estoque'},
      {checked:false, field:'shelf', fieldName:'Prateleira'},
      {checked:false, field:'stockLocation', fieldName:'Localização no Estoque'},
      {checked:false, field:'ncm', fieldName:'NCM'},
      {checked:false, field:'quantity', fieldName:'Quantidade'},
      {checked:false, field:'totalWeight', fieldName:'Peso Total'},
      {checked:false, field:'dimension1', fieldName:'Dimensão 1'},
      {checked:false, field:'dimension2', fieldName:'Dimensão 2'},
      {checked:false, field:'lengthInMm', fieldName:'Comprimento (mm)'},
      {checked:false, field:'costPerKg', fieldName:'Custo por Kg'},
      {checked:false, field:'costPerMm', fieldName:'Custo por mm'},
      {checked:false, field:'totalCost', fieldName:'Custo Total'},
      {checked:false, field:'invoice', fieldName:'Nota Fiscal'},
      {checked:false, field:'density', fieldName:'Densidade'},
      {checked:false, field:'certificates', fieldName:'Certificados'},
      {checked:false, field:'availableBalance', fieldName:'Saldo Disponível'},
      {checked:false, field:'totalCmc', fieldName:'Total CMC'},
      {checked:false, field:'trackingNumber', fieldName:'Número de Rastreamento'},
      {checked:false, field:'receivedDate', fieldName:'Data de Recebimento'},
      {checked:false, field:'purchaseOrder', fieldName:'Ordem de Compra'},
      {checked:false, field:'nf', fieldName:'NF'},
      {checked:false, field:'certificateNumber', fieldName:'Número do Certificado'},
      {checked:false, field:'heatNumber', fieldName:'Número da Corrida'},
      {checked:false, field:'family', fieldName:'Família'},
      {checked:false, field:'description', fieldName:'Descrição'},
      {checked:false, field:'stockStatus', fieldName:'Status do Estoque'},
      {checked:false, field:'characteristic', fieldName:'Característica'},
      {checked:false, field:'measurementUnit', fieldName:'Unidade de Medida'}
    ]
  },
  {
    tableSection:'movement',
    whichFieldsToShow:[
      { checked: false, field: 'ploomesOrderId', fieldName: 'ID do Pedido (Ploomes)' },
      { checked: false, field: 'rawMaterialName', fieldName: 'Nome da Matéria-Prima' },
      { checked: false, field: 'quantity', fieldName: 'Quantidade' },
      { checked: false, field: 'oldTotalWeight', fieldName: 'Peso Total Anterior' },
      { checked: false, field: 'newTotalWeight', fieldName: 'Novo Peso Total' },
      { checked: false, field: 'oldLengthInMm', fieldName: 'Comprimento Anterior (mm)' },
      { checked: false, field: 'newLengthInMm', fieldName: 'Novo Comprimento (mm)' },
      { checked: false, field: 'status', fieldName: 'Status' },
      { checked: false, field: 'createdAt', fieldName: 'Data de Criação' }
    ]
  },
]